import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    options: {
        customProperties: true
      },
    theme: {
        themes: {
          light: {
            primary: '#cc0000',
            secondary: '#ffffff', //#68AEE0',
            background: '#920202', //#343434
            darkgrey: '#1E1E1E',
            greytext: "#424242",
            lightgrey: "#AEAEAE",
            success: '#0A8137',
            warning: '#ffffff',
            error: '#ffffff',
            errorSnackbar: '#cc0000'
          },
        },
    },
    icons: {
        iconfont: 'mdi' || 'icons8', // default - only for display purposes
    },
});

export default vuetify;
